"use client"

import dynamic from "next/dynamic"
import { useEffect, useState } from "react"

const GlobalEnergyGrid = dynamic(
  () => import("@/components/monolith/energy-grid").then((m) => ({ default: m.GlobalEnergyGrid })),
  { ssr: false },
)

const MOBILE_MAX_PX = 768

/**
 * Canvas grid is expensive on the main thread (resize + draw). On small viewports we skip it
 * entirely; on desktop we wait for idle time so first paint / LCP stay ahead of the graph build.
 */
export function DeferredGlobalEnergyGrid() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${MOBILE_MAX_PX + 1}px)`)
    let disarm: (() => void) | undefined

    const arm = () => {
      disarm?.()
      disarm = undefined
      if (!mq.matches) {
        setShow(false)
        return
      }
      if (typeof window.requestIdleCallback === "function") {
        const id = window.requestIdleCallback(() => setShow(true), { timeout: 2200 })
        disarm = () => window.cancelIdleCallback(id)
      } else {
        const id = window.setTimeout(() => setShow(true), 700)
        disarm = () => window.clearTimeout(id)
      }
    }

    arm()
    mq.addEventListener("change", arm)
    return () => {
      mq.removeEventListener("change", arm)
      disarm?.()
    }
  }, [])

  if (!show) return null
  return <GlobalEnergyGrid />
}
